module.exports = __webpack_public_path__ + "static/media/Emotes-Dot.54ef9907.png";